export default "__VITE_ASSET__CVxJ6BSE__"